<template>
  <div
    class="custom-scrollbar w-full overflow-y-auto border border-neutral-200 bg-white"
    ref="scrollContainer"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { type Ref, provide, ref } from "vue";

const scrollContainer: Ref<HTMLElement | null> = ref(null);

provide("scrollToTop", () => {
  if (scrollContainer.value) {
    scrollContainer.value.scrollTop = 0;
  }
});
</script>
